<template>
    <Select
        v-if="releases.length > 0"
        :modelValue="activeRelease"
        @update:modelValue="setActiveRelease"
        :options="releaseOptions"
        optionLabel="label"
        optionValue="value"
        :placeholder="isLiveMode ? 'Select Release' : 'Working Copy'"
        class="release-selector"
        :showClear="!isLiveMode"
    />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import Select from "primevue/select";
import { computed } from "vue";
import { useRoute } from "vue-router";

import { useReleaseStore } from "@/stores/release-store";

defineOptions({
    name: "ReleaseSelector",
});

const route = useRoute();
const releaseStore = useReleaseStore();
const { releases, activeRelease } = storeToRefs(releaseStore);
const { setActiveRelease } = releaseStore;

const isLiveMode = computed(
    () => route.matched.find((m) => m.meta.mode)?.meta.mode === "live"
);

const releaseOptions = computed(() =>
    releases.value.map((r) => ({ label: r.name, value: r.name }))
);
</script>

<style scoped>
.release-selector {
    min-width: 160px;
    max-width: 220px;
}
</style>
